export default "__VITE_ASSET__DJhWQgC2__"